module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu-sp@2x.33d6ec33.jpg";